import request from '#/utils/request';
import { hydrateJsonBlobError } from '#/utils/blobResponseError';

function parseFilenameFromContentDisposition(header) {
  if (!header || typeof header !== 'string') {
    return null;
  }

  const utf8Match = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/^"|"$/g, '');
    }
  }

  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() || null;
}

/**
 * 下載報價單 Excel（#84 固定模板；草稿／已發出／過期皆可；不含內部備註）。
 * @returns {Promise<{ blob: Blob, filename: string }>}
 */
export async function downloadQuotationExcel(id, fallbackName = 'quotation') {
  try {
    const response = await request.get(`/crm/quotations/${id}/excel`, {
      responseType: 'blob',
    });

    const disposition = response.headers?.['content-disposition']
      ?? response.headers?.['Content-Disposition'];
    const filename = parseFilenameFromContentDisposition(disposition) || `${fallbackName}.xlsx`;

    return {
      blob: response.data,
      filename,
    };
  } catch (error) {
    await hydrateJsonBlobError(error);
    throw error;
  }
}
